import { render, staticRenderFns } from "./DonationFeed.vue?vue&type=template&id=ae91781c"
import script from "./DonationFeed.vue?vue&type=script&lang=js"
export * from "./DonationFeed.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports